<div class="flex flex-col w-full gap-1">
  <button class="group" [attr.data-active]="isOpen()" (click)="isOpen.set(!isOpen())">
    <div class="flex items-center gap-3">
      <span class="size-5" [class]="icon()"></span>
      <div class="flex flex-col text-sm *:text-sm">
        {{ label() }}
      </div>
    </div>
    <span
      class="icon-[material-symbols--keyboard-arrow-down] size-5 text-gray-400 transition-transform"
      [class.rotate-180]="isOpen()"></span>
  </button>
  @if (isOpen()) {
    <div class="relative flex flex-col w-full gap-1">
      <div class="absolute w-px h-full border-r border-gray-300 left-[1.5rem]"></div>
      <ng-content />
    </div>
  }
</div>
